declare module '*.glsl' {
  const value: string;
  // @ts-ignore
  export default value;
}